import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, MediumText, PaperBlock, SmallGrayText } from '@guryou/html-components';
import LocationComponent from 'onboard/components/LocationComponent';

const LocationModal = () => {
  const { t } = useTranslation();
  return (
    <PaperBlock xs={12} margin={0} padding="0">
      <Block padding={6} paddingBottom={6}>
        <MediumText>{t('ONBOARD.location')}</MediumText>
        <SmallGrayText>{t('ONBOARD.selectLocation')}</SmallGrayText>
        <LocationComponent />
      </Block>
    </PaperBlock>
  );
};

export default LocationModal;
